module.exports = __webpack_public_path__ + "img/ElementsOfEmber-800-450.36aa8830.jpg";